module.exports = new __parcel__URL__("product_5.33b96c27.png").toString();